import { Alert } from '@components/alert';
import { useStore } from '@store/GlobalStore';
import { useQuoteStore } from '@store/Quote/QuoteStore';
import { useSearchParams } from 'react-router-dom';

import { shallow } from 'zustand/shallow';

export type ImpersonationAlertBannerProps = {
  otherVisibleAlerts?: boolean;
};
export const ImpersonationAlertBanner = ({ otherVisibleAlerts }: ImpersonationAlertBannerProps) => {
  const [searchParams, setSearchParamsInTheUrl] = useSearchParams();
  const [impersonation, setUserRoles] = useStore((state) => [state.impersonation, state.setUserRoles], shallow);
  const [triggerValidation] = useQuoteStore((state) => [state.triggerValidation], shallow);

  if (!impersonation) {
    return null;
  }

  return (
    <Alert
      type='Info'
      variant='filled'
      ctaText='Exit View'
      ctaFunction={() => {
        searchParams.delete('viewReadOnly');
        setSearchParamsInTheUrl(searchParams);
        setUserRoles({ ...impersonation?.userOriginalAuthState, impersonation: undefined });
        triggerValidation();
      }}
      sx={{ marginBottom: otherVisibleAlerts ? '1px' : 'auto' }}
    >
      You are viewing as a {impersonation?.viewingAs}
    </Alert>
  );
};
